import React, { Component } from "react";
import ReactDOM from "react-dom";

import styles from "./intelligenceTimeRangeList.module.scss";

class IntelligenceTimeRangeListDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.handleDropDownToggleOut = this.handleDropDownToggleOut.bind(this);
  }

  componentDidUpdate() {
    if (this.state.open) {
      document.addEventListener("click", this.handleDropDownToggleOut, false);
    } else {
      document.removeEventListener("click", this.handleDropDownToggleOut, false);
    }
  }

  handleDropDownToggle() {
    this.setState({ open: !this.state.open });
  }

  handleDropDownToggleOut(event) {
    const domNode = ReactDOM.findDOMNode(this.refs.timeRangeList);
    if (!domNode || !domNode.contains(event.target)) {
      this.setState({
        open: false,
      });
    }
  }

  handleClick(days, isFull) {
    const { handleClick } = this.props;

    handleClick(days, isFull);
    this.setState({ open: false });
  }

  render() {
    const { title } = this.props;
    const { open } = this.state;

    return (
      <React.Fragment>
        <span
          onClick={(e) => {
            e.stopPropagation()
            this.handleDropDownToggle();
          }}
          className={styles.control}
        >
          {title}
        </span>
        {open ? (
          <div className={styles.rangeListDropdown} ref="timeRangeList">
            <span onClick={this.handleClick.bind(this, 2, false)}>Позавчера</span>
            <span onClick={this.handleClick.bind(this, 2, true)}>Последние 2 дня</span>
            <span onClick={this.handleClick.bind(this, 3, true)}>Последние 3 дня</span>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

export default IntelligenceTimeRangeListDropdown;
